import { render } from "./AppleLoginButton.vue?vue&type=template&id=5473452d&scoped=true"
import script from "./AppleLoginButton.vue?vue&type=script&lang=js"
export * from "./AppleLoginButton.vue?vue&type=script&lang=js"

import "./AppleLoginButton.vue?vue&type=style&index=0&id=5473452d&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5473452d"]])

export default __exports__